import { BrowserDetector } from "../functions/browserDetector";

export const useSupportedBrowser = () => {
  const isSupported = new BrowserDetector().isSupported();
  return isSupported;
};
